const palette = {
  white: '#fff',
  black: '#000',
  grey: '#565656',
  fontGrey: '#747474'
}

export { palette }
